export default () => {
  return <>
    <div className="game-cloud-desktop-1">
      <img src="/resources/game/cloud/desktop-1/1.png" alt=""/>
      <img src="/resources/game/cloud/desktop-1/2.png" alt=""/>
    </div>
  </>
}